import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import { Router } from '@angular/router';

declare var swal: any;
@Injectable()
export class SrubUpService {
  public baseurl: string = environment.base_url;
  constructor(private http: Http, private router: Router) {}
  public loading = false;

  getPackageTypesFeaturesByUserId(
    token: any,
    currentRoute?: string
  ): Observable<any> {
    var url =
      this.baseurl + "api/packagetypesfeatures/GetPackageTypesFeaturesbyUserId";
    var bearer = "Bearer " + token.access_token;
    let body = {};
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "get" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getUserRoleDetails(token: any): Observable<any> {
    var url = this.baseurl + "api/AdminReports/GetUserRoles";
    var bearer = "Bearer " + token.access_token;
    let body = {};
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Get Package Types List
  getPackageTypesList(token: any): Observable<any> {
    var url = this.baseurl + "api/packagetypesfeatures/GetPackageTypesList";
    var bearer = "Bearer " + token.access_token;
    let body = {};
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "get" });
    return this.http
      .get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Get Package Details by Package Type ID
  getPackageTypeByID(token: any, packageTypeID: number): Observable<any> {
    var url =
      this.baseurl +
      "api/packagetypesfeatures/GetPackageTypeByPackageTypeID?packageTypeID=" +
      packageTypeID;
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "get" });
    return this.http
      .get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Update Package Type Features by Package Type ID
  updatePackageTypeFeaturesByID(token: any, payload: any): Observable<any> {
    var url =
      this.baseurl +
      "api/packagetypesfeatures/UpdatePackageTypeFeaturesByPackageTypeID";
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(payload);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getUserReportDetails(token: any, pageNumber: any, pageSize: any) {
    const url = `${this.baseurl}api/AdminReports/GetUsers?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    const bearer = "Bearer " + token.access_token;
    let body = {};
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // # Speciality
  AddSpeciality(token: any, speciality: any) {
    //var url = this.baseurl+'api/Speciality/AddSpeciality';
    var url = this.baseurl + "api/Speciality/AddEditSpeciality_Web";
    let options = new RequestOptions({
      headers: new Headers({ Authorization: "Bearer " + token.access_token }),
    });
    return this.http
      .post(url, speciality, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  AssignSpecialities(
    token: any,
    specialityIds: any,
    userId: number
  ): Observable<any> {
    var url =
      this.baseurl + "api/Speciality/AssignSpecialities?userID=" + userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(specialityIds);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetImage(
    token: any,
    imageUrl: any,
    userId: number,
    isAdminModulePath: boolean = false
  ) {
    var modulePath = "";
    if (userId == 1) {
      modulePath = "Admin";
    }
    if (isAdminModulePath) {
      modulePath = "Admin";
      userId = 1;
    }
    var url =
      this.baseurl + "api/Speciality/GetUploadedImage?imageName=" + imageUrl;
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
      Modulepath: modulePath,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  GetImageFormanageApproval(token: any, imageUrl: any, userId: number) {
    var modulePath = "";
    if (userId == 1) {
      modulePath = "Admin Module";
    }
    var url =
      this.baseurl + "api/Speciality/GetUploadedImage?imageName=" + imageUrl;
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
      Modulepath: modulePath,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getDefaultSpecialities(token: any) {
    var url = "";
    url = this.baseurl + "api/Speciality/GetDefaultSpecialitiesListForDownload";
    var bearer = "Bearer " + token.access_token;
    let body = {};
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  handleError = (error) => {
    console.log(error["status"]);
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    if (error["status"] == 401) {
      this.router.navigate(["/login"]);
    }
    if (error["status"] == 500) {
      this.loading = false;
      swal({
        title: "something went wrong",
        type: "success",
        timer: 3000,
        showConfirmButton: false,
      }).catch(swal.noop);
    }
    if (error["status"] == 504 || error["status"] == 0) {
      this.loading = false;
      swal({
        title: "Timeout please try again",
        type: "success",
        timer: 3000,
        showConfirmButton: false,
      }).catch(swal.noop);
    }

    return Observable.throw(errMsg);
  };
  // private handleError(error: Response | any) {
  //     // In a real world app, you might use a remote logging infrastructure
  //      let errMsg: string;
  //     if (error instanceof Response) {
  //         const body = error.json() || '';
  //         const err = body.error || JSON.stringify(body);
  //         errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
  //     } else {
  //         errMsg = error.message ? error.message : error.toString();
  //     }
  //    // console.error(errMsg);
  //     // this.router.navigate('/login');\
  //     this.router.navigateByUrl("/login");
  //     return  Observable.throw(errMsg);
  //    //return Observable.throw(errMsg);
  // }

  GetSpecialities(
    token: any,
    userId: number,
    getAdminValues: boolean
  ): Observable<any> {
    var url = "";
    let body = {};

    if (userId == 1) {
      body = {
        userId: userId,
      };
      url = this.baseurl + "api/Speciality/GetSpecialitiesList_Web";
      // url= this.baseurl + 'api/Speciality/GetSpecialitiesList?userID=' + userId+'&getAdminValues=' + getAdminValues;
      // url= this.token.webAPIURL+'Speciality/GetSpecialitiesList?userID=' + userId+'&getAdminValues=' + getAdminValues;
    } else {
      url = this.baseurl + "api/Speciality/GetUserSpecialityList";

      //  url= this.baseurl + 'api/Speciality/GetSpecialitiesList_Web';
      //url= this.baseurl + 'api/Speciality/GetSpecialitiesListForWeb?userID=' + userId+'&getAdminValues=' + getAdminValues;
      //url= this.token.webAPIURL+'Speciality/GetSpecialitiesListForWeb?userID=' + userId+'&getAdminValues=' + getAdminValues;
    }
    //console.log(token.access_token);
    var bearer = "Bearer " + token.access_token;

    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetSpecialitiesToRelease(token: any): Observable<any> {
    var url = this.baseurl + "api/Speciality/GetSpecialitiesToRelease";
    var bearer = "Bearer " + token.access_token;

    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetAnalyticsData(token: any): Observable<any> {
    var url = this.baseurl + "api/Speciality/GetAnalyticsData";
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  ReleaseSpecialityToStore(
    token: any,
    specialityId: number,
    userId: any
  ): Observable<any> {
    var url =
      this.baseurl +
      "api/Speciality/ReleaseSpecialityToStore?specialityId=" +
      specialityId +
      "&UserID=" +
      userId;
    let body = JSON.stringify("");
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  DeleteSpeciality(token: any, specialityId: any) {
    var url = this.baseurl + "api/Speciality/DeleteSpeciality_Web";
    let body = JSON.stringify(specialityId);
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // # Procedure
  AddProcedure(token: any, procedure: any): Observable<any> {
    // var url = this.baseurl+'api/Procedure/AddProcedure';
    var url =
      this.baseurl + "api/Procedure/AddEditUserProcedureBySpecialityID_Web";
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(procedure);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //changes by
  DeleteProcedures(token: any, procedureSpecArray: any): Observable<any> {
    var url =
      this.baseurl + "api/Procedure/DeleteUserProcedureBySpecialityID_Web";
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(procedureSpecArray);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetProcedures(
    token: any,
    userId: number,
    getAdminValues: boolean
  ): Observable<any> {
    var url =
      this.baseurl +
      "api/Procedure/GetProcedureList?userID=" +
      userId +
      "&getAdminValues=" +
      getAdminValues;
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //use for user panel
  GetSpecialityProcedures(token: any, sId: any): Observable<any> {
    var url = this.baseurl + "api/Speciality/GetProceduresBySpecialityID";
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(sId);

    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //changes by use for admin panel
  GetOnlySpecialityProcedures(token: any, sId: any): Observable<any> {
    var url = this.baseurl + "api/Speciality/GetProceduresBySpecialityID_Web";
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(sId);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  AssignProcedures(
    token: any,
    assignedProcedureIds: any,
    specialityId: number,
    userId: number
  ): Observable<any> {
    var url =
      this.baseurl +
      "api/Procedure/AssignProcedures?specialityId=" +
      specialityId +
      "&userID=" +
      userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(assignedProcedureIds);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  DeleteProcedure(
    token: any,
    specialityId: number,
    procedureId: string,
    userId: number
  ) {
    var url =
      this.baseurl +
      "api/Speciality/DeleteSpeciality?specialityId=" +
      specialityId +
      "&procedureId=" +
      procedureId +
      "&userID=" +
      userId;
    let body = JSON.stringify("");
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // # Equipment
  AddEquipment(token: any, equipment: any, userId: any): Observable<any> {
    var url = this.baseurl + "api/Equipment/AddEquipment";
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(equipment);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  AddUserEquipment(token: any, equipment: any): Observable<any> {
    // var url = this.baseurl+'api/Equipment/AddUserEquipment?userID='+userId+'&specialityId=' + specialityId + '&procedureId=' + procedureId;
    var url = this.baseurl + "api/Equipment/UserEquipmentsAddEdit_Web";
    var bearer = "Bearer " + token.access_token;
    //let body = JSON.stringify(equipment);
    let headers = new Headers({ Authorization: bearer });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, equipment, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  UpdateUserEquipment(
    token: any,
    equipment: any,
    specialityId: any,
    procedureId: any,
    userId: any
  ): Observable<any> {
    var url =
      this.baseurl +
      "api/Equipment/UpdateUserEquipment?userID=" +
      userId +
      "&specialityId=" +
      specialityId +
      "&procedureId=" +
      procedureId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(equipment);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  AddCategory(token: any, category: any, userId: any): Observable<any> {
    var url = this.baseurl + "api/Equipment/AddCategory";
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(category);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetEquipmentList(token: any, userId: number): Observable<any> {
    var url = this.baseurl + "api/Equipment/GetEquipmentList";
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetSelectedCategoryEquipments(
    token: any,
    userId: number,
    categryId: any
  ): Observable<any> {
    // var url = this.baseurl+'api/Equipment/GetSelectedCategoryEquipments?categryName='+categryName;
    var url =
      this.baseurl +
      "api/Equipment/GetSelectedCategoryEquipments_Web?CategoryId=" +
      categryId;
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({ Authorization: bearer, UserId: userId });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetSelectedEquipmentSpecifications(
    token: any,
    userId: number,
    catgryId: any,
    eqpmentName: any
  ): Observable<any> {
    //  var url = this.baseurl+'api/Equipment/GetSelectedEquipmentSpecifications?catgryName='+catgryName+'&eqpmentName=' + eqpmentName;
    var url =
      this.baseurl +
      "api/Equipment/GetSelectedEquipmentSpecifications_Web?CategoryId=" +
      catgryId +
      "&EqpmentName=" +
      eqpmentName;
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({ Authorization: bearer });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  UserEquipmentsListByUserProcedureID(token: any, pid: any): Observable<any> {
    var url =
      this.baseurl + "api/Equipment/UserEquipmentsListByUserProcedureID";
    var bearer = "Bearer " + token.access_token;
    let body = {
      UserProcedureID: pid,
    };
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  SurgeonEquipmentsListByUserProcedureID(
    token: any,
    spId: any,
    surgonId: any
  ): Observable<any> {
    var url =
      this.baseurl + "api/Equipment/SurgeonEquipmentsListByUserProcedureID";
    var bearer = "Bearer " + token.access_token;
    let body = {
      SurgeonProcedureID: spId,
      SurgeonId: surgonId,
    };
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetEquipmentCategoryList(token: any, userId: number): Observable<any> {
    var url = this.baseurl + "api/Equipment/EquipmentCategoryList_Web";
    var bearer = "Bearer " + token.access_token;
    let body = {};
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  AssignEquipments(token: any, udto: any, userId: any) {
    var url = this.baseurl + "api/Equipment/AssignEquipments";
    let body = JSON.stringify(udto);
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  ShareProcedure(
    token: any,
    shareProcedureToUserIds: any,
    specialityId: number,
    selectedProcedureId: number,
    userId: number,
    dateTime: any
  ): Observable<any> {
    var url =
      this.baseurl +
      "api/Procedure/ShareProcedure?specialityId=" +
      specialityId +
      "&loginUserID=" +
      userId +
      "&procedureId=" +
      selectedProcedureId +
      "&dtTime=" +
      dateTime;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(shareProcedureToUserIds);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  DeleteAssignEquipment(token: any, toDeleteID: any): Observable<any> {
    var url = this.baseurl + "api/Equipment/UserEquipmentsDelete_Web";
    var bearer = "Bearer " + token.access_token;
    let body = { UEID: toDeleteID };
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetAssignedEquipmentsList(token: any, pid: any): Observable<any> {
    //  var url = this.baseurl+'api/Equipment/GetAssignedEquipmentsList?specialityId=' + specialityId + '&procedureId=' + procedureId + '&userId=' + userId;
    var url =
      this.baseurl + "api/Equipment/UserEquipmentsListByUserProcedureID_Web";
    let body = {
      UserProcedureID: pid,
    };
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // # OperationRoom
  AddOperationRoom(token: any, udto: any, userId: any) {
    var url = this.baseurl + "api/Operation/AddOperationRoom";
    let body = JSON.stringify(udto);
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  editGgetPatientPosition(token: any, UserProcedureID: any): Observable<any> {
    var bearer = "Bearer " + token.access_token;
    let body = {
      Id: UserProcedureID,
    };
    var url =
      this.baseurl + "api/PatientPositioning/GetPatientPositioningsById_Web";
    let options = new RequestOptions({
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: bearer,
      }),
    });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  editGetuserProcedurechecklist(
    token: any,
    UserProcedureID: any
  ): Observable<any> {
    var bearer = "Bearer " + token.access_token;
    let body = {
      UserProcedureCheckListID: UserProcedureID,
    };
    var url =
      this.baseurl +
      "api/Preparation/GetUserProcedureCheckListsImagesByProcedureCheckListID_Web";
    let options = new RequestOptions({
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: bearer,
      }),
    });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetPressurePoint(token: any): Observable<any> {
    var bearer = "Bearer " + token.access_token;
    let body = {};
    var url = this.baseurl + "api/PatientPositioning/GetPressurePoints";
    let options = new RequestOptions({
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: bearer,
      }),
    });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetSurgeonPatientPositionings(token: any, procedureId: any): Observable<any> {
    var bearer = "Bearer " + token.access_token;
    let body = { SurgeonProcedureID: procedureId };
    var url =
      this.baseurl + "api/PatientPositioning/GetSurgeonPatientPositionings";
    let options = new RequestOptions({
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: bearer,
      }),
    });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  GetPatientPositioningsById_app(
    token: any,
    procedureId: any,
    FeatureValue: any,
    IsPackageDowngraded: boolean
  ): Observable<any> {
    var bearer = "Bearer " + token.access_token;
    let body = { UserProcedureID: procedureId, FeatureValue: FeatureValue, IsPackageDowngraded: IsPackageDowngraded };
    var url =
      this.baseurl + "api/PatientPositioning/GetUserPatientPositionings";
    let options = new RequestOptions({
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: bearer,
      }),
    });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetPatientPositioningsById(token: any, procedureId: any): Observable<any> {
    var bearer = "Bearer " + token.access_token;
    let body = { UserProcedureID: procedureId };
    var url =
      this.baseurl + "api/PatientPositioning/GetPatientPositionings_Web";
    let options = new RequestOptions({
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: bearer,
      }),
    });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getuserProcedurechecklistItem(
    token: any,
    CheckListTypeID: any,
    UserProcedureID: any,
    FeatureValue: any,
    IsPackageDowngraded: boolean
  ): Observable<any> {
    // const
    var bearer = "Bearer " + token.access_token;
    let body = {
      CheckListTypeID: CheckListTypeID,
      UserProcedureID: UserProcedureID,
      FeatureValue: FeatureValue,
      IsPackageDowngraded: IsPackageDowngraded,
    };
    var url =
      this.baseurl + "api/Preparation/GetUserProcedureCheckListsByIDandTypeID";
    let options = new RequestOptions({
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: bearer,
      }),
    });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getuserProcedurechecklist(
    token: any,
    CheckListTypeID: any,
    UserProcedureID: any
  ): Observable<any> {
    var bearer = "Bearer " + token.access_token;
    let body = {
      CheckListTypeID: CheckListTypeID,
      UserProcedureID: UserProcedureID,
    };
    var url =
      this.baseurl +
      "api/Preparation/GetUserProcedureCheckListsByIDandTypeID_Web";
    let options = new RequestOptions({
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: bearer,
      }),
    });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getSurgonProcedurechecklist(
    token: any,
    CheckListTypeID: any
  ): Observable<any> {
    var bearer = "Bearer " + token.access_token;
    var url =
      this.baseurl + "api/Surgeon/GetSurgeonProcedureCheckListsByIDandTypeID";
    let options = new RequestOptions({
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: bearer,
      }),
    });
    return this.http
      .post(url, CheckListTypeID, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // GetOperationRoomDetails(token: any, specialityId: number, procedureId: string, userId: number): Observable<any> {
  //     var url = this.baseurl+'api/Operation/GetOperationRoomDetails?specialityId=' + specialityId + '&procedureId=' + procedureId + '&userId=' + userId;;
  //     var bearer = 'Bearer ' + token.access_token;
  //     let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': bearer ,'UserId': userId });
  //     let options = new RequestOptions({ headers: headers });
  //     return this.http.get(url, options)
  //         .map(this.extractData)
  //         .catch(this.handleError);
  // }

  DeleteOperationRoomDetails(
    token: any,
    specialityId: number,
    procedureId: string,
    userId: any
  ) {
    var url =
      this.baseurl +
      "api/Operation/DeleteOperationRoomDetails?specialityId=" +
      specialityId +
      "&procedureId=" +
      procedureId;
    let body = JSON.stringify("");
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // # PatientPositioning
  AddPatientPositioning(token: any, udto: any, userId: any) {
    var url = this.baseurl + "api/PatientPositioning/AddPatientPositioning";
    let body = JSON.stringify(udto);
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // GetPatientPositioningDetails(token: any, specialityId: number, procedureId: string, userId: number): Observable<any> {
  //     var url = this.baseurl+'api/PatientPositioning/GetPatientPositioningDetails?specialityId=' + specialityId + '&procedureId=' + procedureId + '&userId=' + userId;
  //     var bearer = 'Bearer ' + token.access_token;
  //     let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': bearer,'UserId': userId });
  //     let options = new RequestOptions({ headers: headers });
  //     return this.http.get(url, options)
  //         .map(this.extractData)
  //         .catch(this.handleError);
  // }

  DeletePatientPositoningDetails(
    token: any,
    specialityId: number,
    procedureId: string,
    userId: any
  ) {
    var url =
      this.baseurl +
      "api/PatientPositioning/DeletePatientPositoningDetails?specialityId=" +
      specialityId +
      "&procedureId=" +
      procedureId;
    let body = JSON.stringify("");
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // # Preparation
  AddPreparation(token: any, udto: any, userId: any) {
    var url = this.baseurl + "api/Preparation/AddPreparation";
    let body = JSON.stringify(udto);
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // GetPreparationDetails(token: any, specialityId: number, procedureId: string, userId: number): Observable<any> {
  //     var url = this.baseurl+'api/Preparation/GetPreparationDetails?specialityId=' + specialityId + '&procedureId=' + procedureId + '&userId=' + userId;
  //     var bearer = 'Bearer ' + token.access_token;
  //     let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': bearer ,'UserId': userId });
  //     let options = new RequestOptions({ headers: headers });
  //     return this.http.get(url, options)
  //         .map(this.extractData)
  //         .catch(this.handleError);
  // }

  DeletePreparation(
    token: any,
    specialityId: number,
    procedureId: string,
    userId: any
  ) {
    var url =
      this.baseurl +
      "api/Preparation/DeletePreparationDetails?specialityId=" +
      specialityId +
      "&procedureId=" +
      procedureId;
    let body = JSON.stringify("");
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // # Notes
  AddImages(token: any, udto: any, categoryId: number, userId: any) {
    var url = "";
    if (categoryId == 1) {
      url = this.baseurl + "api/Operation/AddImages";
    } else if (categoryId == 2) {
      url = this.baseurl + "api/PatientPositioning/AddImages";
    } else if (categoryId == 3) {
      url = this.baseurl + "api/Notes/AddImages";
    } else if (categoryId == 4) {
      url = this.baseurl + "api/Preparation/AddImages";
    }

    let body = JSON.stringify(udto);
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  DeleteUserImages(token: any, deleteObj: any) {
    var url =
      this.baseurl + "api/Preparation/SurgeonDeleteCheckListByCheckListID";
    // if (categoryId == 1) {
    //     url = this.baseurl + "api/Operation/DeleteImage?userId="+ userId;
    // }
    // else if (categoryId == 2) {
    //     url = this.baseurl + "api/PatientPositioning/DeleteImage?userId="+ userId;
    // }
    // else if (categoryId == 3) {
    //     url = this.baseurl + "api/Notes/DeleteImage?userId="+ userId;
    // }
    // else if (categoryId == 4) {
    //     url = this.baseurl + "api/Preparation/DeleteImage?userId="+ userId;
    // }

    let body = JSON.stringify(deleteObj);
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  DeleteImages(token: any, deleteObj: any, userId: any) {
    if (userId == 1)
      var url =
        this.baseurl + "api/Preparation/DeleteCheckListByCheckListID_Web";
    else
      var url = this.baseurl + "api/Preparation/DeleteCheckListByCheckListID";
    // if (categoryId == 1) {
    //     url = this.baseurl + "api/Operation/DeleteImage?userId="+ userId;
    // }
    // else if (categoryId == 2) {
    //     url = this.baseurl + "api/PatientPositioning/DeleteImage?userId="+ userId;
    // }
    // else if (categoryId == 3) {
    //     url = this.baseurl + "api/Notes/DeleteImage?userId="+ userId;
    // }
    // else if (categoryId == 4) {
    //     url = this.baseurl + "api/Preparation/DeleteImage?userId="+ userId;
    // }

    //let body = JSON.stringify(deleteObj);
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, deleteObj, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  AddPatientPosition(token: any, checklist: any): Observable<any> {
    var url =
      this.baseurl + "api/PatientPositioning/AddEditPatientPositionings_Web";
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({ Authorization: bearer });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, checklist, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  AddCheckList(token: any, checklist: any): Observable<any> {
    var url =
      this.baseurl + "api/Preparation/AddEditCheckListByCheckListID_Web";
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({ Authorization: bearer });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, checklist, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  updateCheckList(token: any, checklist: any): Observable<any> {
    var url =
      this.baseurl + "api/Preparation/UpdateCheckListByCheckListImagesByID_Web";
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({ Authorization: bearer });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, checklist, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  DeletePatientPosition(token: any, udto: any): Observable<any> {
    var url =
      this.baseurl + "api/PatientPositioning/DeletePatientPositionings_Web";
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, udto, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  DeleteCheckList(token: any, udto: any): Observable<any> {
    var url = this.baseurl + "api/Preparation/DeleteCheckListByCheckListID_Web";
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, udto, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  AddVideos(token: any, udto: any, categoryId: number, userId: any) {
    var url = "";
    if (categoryId == 1) {
      url = this.baseurl + "api/Operation/AddVideos";
    } else if (categoryId == 2) {
      url = this.baseurl + "api/PatientPositioning/AddVideos";
    } else if (categoryId == 3) {
      url = this.baseurl + "api/Notes/AddVideos";
    } else if (categoryId == 4) {
      url = this.baseurl + "api/Preparation/AddVideos";
    }

    let body = JSON.stringify(udto);
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  DeleteVideo(token: any, udto: any, categoryId: number, userId: any) {
    var url = "";
    if (categoryId == 1) {
      url = this.baseurl + "api/Operation/DeleteVideo?userId=" + userId;
    } else if (categoryId == 2) {
      url =
        this.baseurl + "api/PatientPositioning/DeleteVideo?userId=" + userId;
    } else if (categoryId == 3) {
      url = this.baseurl + "api/Notes/DeleteVideo?userId=" + userId;
    } else if (categoryId == 4) {
      url = this.baseurl + "api/Preparation/DeleteVideo?userId=" + userId;
    }

    let body = JSON.stringify(udto);
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // # Notes
  AddNotes(token: any, udto: any, userId: any) {
    var url = this.baseurl + "api/Notes/AddNotes";
    let body = JSON.stringify(udto);
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // GetNotes(token: any, specialityId: number, procedureId: string, userId: number): Observable<any> {
  //     var url = this.baseurl+'api/Notes/GetNotes?specialityId=' + specialityId + '&procedureId=' + procedureId + '&userId=' + userId;;
  //     var bearer = 'Bearer ' + token.access_token;
  //     let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': bearer ,'UserId': userId});
  //     let options = new RequestOptions({ headers: headers });
  //     return this.http.get(url, options)
  //         .map(this.extractData)
  //         .catch(this.handleError);
  // }

  DeleteNotes(
    token: any,
    specialityId: number,
    procedureId: string,
    userId: any
  ) {
    var url =
      this.baseurl +
      "api/Notes/DeleteNotes?specialityId=" +
      specialityId +
      "&procedureId=" +
      procedureId;
    let body = JSON.stringify("");
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // AddImage(token: any, imageDTO, specialityId, procedureId, categoryId, userId) {
  //     var url = this.baseurl + "api/Procedure/AddImage?specialityId=" + specialityId + "&procedureId=" + procedureId + "&categoryId=" + categoryId + "&userId=" + userId;
  //     let body = JSON.stringify(imageDTO);
  //     var bearer = 'Bearer ' + token.access_token;
  //     let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': bearer ,'UserId': userId});
  //     let options = new RequestOptions({ headers: headers, method: "post" });
  //     return this.http.post(url, body, options)
  //         .map(this.extractData)
  //         .catch(this.handleError);
  // }

  surgonProcedureListBySurgonId(token: any, surgonId: any) {
    var url = this.baseurl + "api/Surgeon/UserSurgeonProcedureListBySurgeonId";
    var bearer = "Bearer " + token.access_token;
    let body = {
      //  "UserSpecialityID": 451,
      SurgeonId: surgonId,
    };
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // #Surgeon

  GetSurgeons(
    token: any,
    userId: number,
    UserSpecialityID: any,
    FeatureValue: any,
    IsPackageDowngraded: boolean
  ): Observable<any> {
    //var url = this.baseurl+'api/Surgeon/GetSurgeonList?userID=' + userId;
    var url = this.baseurl + "api/Surgeon/UserSurgeonList";
    var bearer = "Bearer " + token.access_token;
    let body = {
      UserSpecialityID: UserSpecialityID,
      UserProcedureID: 0,
      FeatureValue: FeatureValue,
      IsPackageDowngraded: IsPackageDowngraded,
    };
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    // return this.http.get(url, options)
    //     .map(this.extractData)
    //     .catch(this.handleError);
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  AddSurgeon(token: any, surgeon: any, userId: number): Observable<any> {
    var url = this.baseurl + "api/Surgeon/AddSurgeon?userID=" + userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(surgeon);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  AddSurgeonNotes(
    token: any,
    surgeonNote: any,
    userId: number
  ): Observable<any> {
    var url = this.baseurl + "api/Surgeon/AddNote?userID=" + userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(surgeonNote);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  GetSurgeonNotes(token: any, surgeonId: any): Observable<any> {
    var url = this.baseurl + "api/Surgeon/SurgeonsNoteListBySurgeonID";
    // var url = this.baseurl+'api/Surgeon/GetSurgeonNotes?userID=' + userId+'&surgeonId=' + surgeonId;
    var bearer = "Bearer " + token.access_token;
    let body = {
      //"UserSpecialityID": 451,
      SurgeonId: surgeonId,
    };
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  UpdateSurgeonNote(
    token: any,
    surgeonNote: any,
    userId: number
  ): Observable<any> {
    var url = this.baseurl + "api/Surgeon/UpdateSurgeonNote?userID=" + userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(surgeonNote);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  DeleteSurgeonNote(
    token: any,
    noteId: any,
    surgeonId: any,
    userId: number
  ): Observable<any> {
    var url =
      this.baseurl +
      "api/Surgeon/DeleteSurgeonNote?userID=" +
      userId +
      "&surgeonId=" +
      surgeonId +
      "&noteId=" +
      noteId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify("");
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  UpdateSurgeon(token: any, surgeon: any, userId: number): Observable<any> {
    var url = this.baseurl + "api/Surgeon/UpdateSurgeon?userID=" + userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(surgeon);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  DeleteSurgeon(token: any, surgeonId: any, userId: number): Observable<any> {
    var url = this.baseurl + "api/Surgeon/DeleteSurgeon?userID=" + userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(surgeonId);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  ShareSurgeon(
    token: any,
    shareSurgeonToUserIds: any,
    selectedSurgeonId: string,
    userId: number,
    dateTime: any
  ): Observable<any> {
    var url =
      this.baseurl +
      "api/Surgeon/ShareSurgeon?surgeonId=" +
      selectedSurgeonId +
      "&loginUserID=" +
      userId +
      "&dtTime=" +
      dateTime;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(shareSurgeonToUserIds);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // #Journal

  GetJournals(token: any, userId: number): Observable<any> {
    var url = this.baseurl + "api/Journal/GetJournalbyUserId";
    // var url = this.baseurl+'api/Journal/GetJournalList?userID=' + userId;
    var bearer = "Bearer " + token.access_token;
    let body = {
      Surgeons: "",
      Procedures: "",
      TimeRange: "customs range",
      StartDate: "2000-01-01",
      EndDate: "2090-01-31",
      Month: "",
      Year: "",
    };
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  AddJournal(token: any, journal: any, userId: number): Observable<any> {
    var url = this.baseurl + "api/Journal/AddJournal?userID=" + userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(journal);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  UpdateJournal(token: any, journal: any, userId: number): Observable<any> {
    var url = this.baseurl + "api/Journal/UpdateJournal?userID=" + userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(journal);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Contacts
  GetContactsInfo(token: any, userId: number): Observable<any> {
    //var url = this.baseurl+'api/Contacts/GetContactsInfo?userID=' + userId;
    var url = this.baseurl + "api/Contacts/GetContactsbyUserId";
    var bearer = "Bearer " + token.access_token;
    let body = {};
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  impersonateLogin(username: any, token): Observable<any> {
    const accessToken = token.access_token ? token.access_token : token;
    var bearer = "Bearer " + accessToken;
    var url = this.baseurl + "api/Account/ImpersonateLogin2";
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(
        this.baseurl + "api/Account/ImpersonateLogin",
        "userName=" + encodeURIComponent(username),
        options
      )
      .map(this.extractData)
      .catch(this.handleError);
  }
  GetSearchUsersContactInfo(
    token: any,
    userId: number,
    searchUser: string
  ): Observable<any> {
    token = typeof token == "string" ? token : token.access_token;
    var url =
      this.baseurl +
      "api/Contacts/GetSearchUsersContactInfo?userID=" +
      userId +
      "&searchItem=" +
      searchUser.trim();
    var bearer = "Bearer " + token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetSearchUserDetails(
    token: any,
    userId: number,
    pageNumber: number,
    pageSize: number,
    searchUser: string,
    workplaceType: string,
    plateFormType: string,
    packageType: string,
    role: string,
    fromDate: string,
    toDate: string
  ): Observable<any> {
    var url = `${
      this.baseurl
    }api/AdminReports/GetSearchUsers?searchText=${searchUser.trim()}&pageNumber=${pageNumber}&pageSize=${pageSize}&role=${role}&workplaceType=${workplaceType}&plateformType=${plateFormType}&fromDate=${fromDate}&toDate=${toDate}&packageType=${packageType}`;
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getDefaultDesignationRoleMasterList(token: any, userId: number) {
    var url = `${this.baseurl}api/Account/GetDefaultDesignationRoleMasterList`;
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, {}, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  SendInviteToAddToContacts(
    token: any,
    addToContactUserIds: any,
    userId: number
  ): Observable<any> {
    var url =
      this.baseurl + "api/Contacts/SendInviteToAddToContacts?userID=" + userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(addToContactUserIds);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  CreateContactsGroup(
    token: any,
    addToGroupUserIds: any,
    groupName: any,
    userId: number
  ): Observable<any> {
    var url =
      this.baseurl +
      "api/Contacts/CreateContactsGroup?userID=" +
      userId +
      "&groupName=" +
      groupName;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(addToGroupUserIds);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  AcceptAddToContactRequest(
    token: any,
    acceptedUserId: number,
    userId: number
  ): Observable<any> {
    var url =
      this.baseurl +
      "api/Contacts/AcceptAddToContactRequest?userID=" +
      userId +
      "&acceptedUserId=" +
      acceptedUserId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify("");
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  DenyAddToContactRequest(
    token: any,
    deniedUserId: number,
    userId: number
  ): Observable<any> {
    var url =
      this.baseurl +
      "api/Contacts/DenyAddToContactRequest?userID=" +
      userId +
      "&deniedUserId=" +
      deniedUserId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify("");
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  DeleteContact(
    token: any,
    toDeleteUserId: number,
    toDeleteGroupId: any,
    userId: number
  ): Observable<any> {
    //var url = this.baseurl+'api/Contacts/DeleteContact?userID=' + userId + "&toDeleteUserId=" + toDeleteUserId+"&toDeleteGroupId=" + toDeleteGroupId;
    var url = this.baseurl + "api/Contacts/DeleteContact";
    var bearer = "Bearer " + token.access_token;
    let body = { Id: toDeleteUserId };
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // #Professional Learning Activity(pla)

  GetPLAs(token: any, userId: number): Observable<any> {
    var url =
      this.baseurl + "api/ProfessionalLearning/GetProfessionalLearningbyUserId";
    let body = {
      Providers: "",
      TimeRange: "",
      StartDate: "2000-01-01",
      EndDate: "2090-01-31",
    };
    //var url = this.baseurl+'api/ProfessionalLearning/GetPLActivityList?userID=' + userId;
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  AddPLA(token: any, pla: any, userId: number): Observable<any> {
    var url =
      this.baseurl + "api/ProfessionalLearning/AddPLActivity?userID=" + userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(pla);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  UpdatePLA(token: any, pla: any, userId: number): Observable<any> {
    var url =
      this.baseurl +
      "api/ProfessionalLearning/UpdatePLActivity?userID=" +
      userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(pla);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // # Manage Approvals.

  GetPendingApprovals(token: any, userId: any): Observable<any> {
    // var url = this.baseurl+'api/Speciality/GetPendingApprovals';
    var url = this.baseurl + "api/Preparation/sharedchecklistreportelist_web";
    var bearer = "Bearer " + token.access_token;
    let body = {};
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  ApproveImages(token: any, approvedImagesList: any): Observable<any> {
    // var url = this.baseurl+'api/Speciality/ApproveImages?userID=' + userId;
    var url =
      this.baseurl + "api/Preparation/sharedchecklistreportestatusupdate_web";
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(approvedImagesList);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  DeclineImages(
    token: any,
    declinedImagesList: any,
    userId: number
  ): Observable<any> {
    var url = this.baseurl + "api/Speciality/DeclineImages?userID=" + userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(declinedImagesList);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // #ShiftDayTime

  GetShifts(token: any, userId: number): Observable<any> {
    var url = this.baseurl + "api/ShiftDayTime/GetShiftDayTimebyUserId";
    let body = {
      Year: "",
      Month: "",
      Mode: "Admin",
    };
    //var url = this.baseurl+'api/ShiftDayTime/GetShiftList?userID=' + userId;
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  AddShift(token: any, pla: any, userId: number): Observable<any> {
    var url = this.baseurl + "api/ShiftDayTime/AddShiftItem?userID=" + userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(pla);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  UpdateShift(token: any, pla: any, userId: number): Observable<any> {
    var url =
      this.baseurl + "api/ShiftDayTime/UpdateShiftItem?userID=" + userId;
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(pla);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
      UserId: userId,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }

  getStatisticsReport(token: any): Observable<any> {
    var url = this.baseurl + "api/AdminReports/GetOtherStatistics";
    var bearer = "Bearer " + token.access_token;
    let body = {};
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  GetsprocedureReport(
    token: any,
    id: any,
    pageNumber: any,
    pageSize: any
  ): Observable<any> {
    var url =
      this.baseurl +
      "api/AdminReports/GetProcedures?SpecialityID=" +
      id +
      "&pageNumber=" +
      pageNumber +
      "&pageSize=" +
      pageSize;
    let body = {};
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetSurgeonReport(token: any): Observable<any> {
    var url = this.baseurl + "api/AdminReports/GetSurgeons";
    let body = {};
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  GetSpecialityReport(token: any): Observable<any> {
    var url = this.baseurl + "api/AdminReports/GetSpecialitiesDownloaded";
    let body = {};
    var bearer = "Bearer " + token.access_token;
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getPackageTypeFeatures(token: any, packageTypeId: number): Observable<any> {
    var url =
      this.baseurl +
      `api/packagetypesfeatures/GetPackageTypeFeaturesList?packageTypeId=${packageTypeId}`;
    var bearer = "Bearer " + token.access_token;
    let body = {};
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  updatePackageTypeFeatures(token: any, payload: any): Observable<any> {
    var url =
      this.baseurl + "api/packagetypesfeatures/UpdatePackageTypeFeatures";
    var bearer = "Bearer " + token.access_token;
    let body = JSON.stringify(payload);
    let headers = new Headers({
      "Content-Type": "application/json",
      Authorization: bearer,
    });
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http
      .post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Services/ScrubUp.service.ts